<template>
    <div class="Favourites">
        <div class="container">
            <h2>{{'Saved Properties' | language}}</h2>

            <div v-if="favorites.data && favorites.data.length > 0 || fullscreenLoading === true" class="row" v-loading="fullscreenLoading" >
                <div v-for="(favorite, index) of favorites.data" :key="index" class="col-xs-12 col-sm-6 col-md-4 SearchResults__CardContainer">
                    <SearchResultListingCard :property="favorite.property" :loading="fullscreenLoading" />
                </div>
            </div>
            <div v-else class="no-results">
                <p>You have no saved properties yet.</p>
                <a href="/properties"><el-button type="primary">Find your dream home now<i class="el-icon-arrow-right el-icon-right"></i></el-button></a>
            </div>
            <div class="row center-xs">
            <div class="col-xs-12 SearchResults__PaginationContainer">
              <el-pagination v-if="favorites.data && favorites.data.length > 0" background layout="prev, pager, next" :page-size="favorites.per_page"
              @current-change="handleCurrentChange" @prev-click="prevClick" @next-click="nextClick"
              :total="favorites.total">
              </el-pagination>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import axios from 'axios'
    import SearchResultListingCard from '../SearchResults/SearchResultListingCard'

    export default {
        components: {
            SearchResultListingCard,
        },
        props: {
        },
        data(){
            return {
                currentPage: 1,
                fullscreenLoading: false,
            }
        },
        computed: {
            ...mapState({
                favorites: (state) => {
                    return state.user.favorites
                }
            }),
        },
        methods: {
            loadFavourites() {
                const params = {
                    page : this.currentPage
                }
                this.fullscreenLoading = true
                const listPromise = this.$store.dispatch('user/favorites',params);
                axios.all([listPromise])
                .finally(()=> {
                    this.fullscreenLoading = false
                })
            },
            handleCurrentChange(e) {
                this.currentPage = e
                this.loadFavourites()
            },
            prevClick(e) {
                this.currentPage = e
            },
            nextClick(e){
                this.currentPage = e
            },
        },

        created() {
            this.loadFavourites();
        },
        head: {
            title: function() {
                return {
                    inner: 'Saved Homes'
                }
            },
            meta: [
                { name: 'title', content: 'Saved homes on Japan Home Finder' },
                { name: 'keywords', content: 'japan home finder, japan realestate, apartment, house, for rent, for lease' },
                { name: 'description', content: 'Making your Japan home search easier' }
            ]
        }
    }
</script>

<style lang="scss" scoped>
    .Favourites {
        padding: 1em 0;

        h2 {
            text-align: center;
        }

        .no-results {
            text-align: center;

            .el-icon-right {
                padding-left: 1em;
            }
        }
    }
</style>